import { action, makeObservable, observable } from 'mobx';

import ApiService from '../services/ApiService';

import { Loadable } from './models/Loadable';
import { PaymentDetails } from './models/PaymentDetails';
import { ISsoStore } from './SsoStore';

export interface IPaymentDetailsStore {
  tryLoadPaymentDetails(bindingId: number): void;

  paymentDetails(bindingId: number): Loadable<PaymentDetails>;

  isLineOpened(dataRowTrigger: string): boolean;

  getOpenLines(): string[];

  setOpenLines(openLines: string[]): void;
}

export default class PaymentDetailsStore implements IPaymentDetailsStore {
  @observable
  private allPaymentDetails: Map<number, Loadable<PaymentDetails>> = new Map();
  @observable
  private openLines: string[] = [];

  constructor(
    private apiService: ApiService,
    private ssoStore: ISsoStore
  ) {
    makeObservable(this);
  }

  @action
  public tryLoadPaymentDetails(bindingId: number): void {
    if (this.allPaymentDetails.has(bindingId)) {
      return;
    }

    const paymentDetails: Loadable<PaymentDetails> = Loadable.toLoadable(this.apiService.getPaymentDetails(this.ssoStore.customer.customerId, bindingId));
    this.allPaymentDetails.set(bindingId, paymentDetails);
  }

  public paymentDetails(bindingId: number): Loadable<PaymentDetails> {
    return this.allPaymentDetails.get(bindingId);
  }

  public isLineOpened(dataRowTrigger: string): boolean {
    return this.openLines.includes(dataRowTrigger);
  }

  public getOpenLines(): string[] {
    return this.openLines;
  }

  @action
  public setOpenLines(openLines: string[]): void {
    this.openLines = openLines;
  }
}
